module.exports = __webpack_public_path__ + "img/docs-file.9ed8c142.svg";